// 가입페이지 랜딩 추적 스크립트
const landing_greenp = () => {
  if (typeof window.grpCpaLand === 'function') {
    window.grpCpaLand()
  }
}

// 가입완료 추적 스크립트
const join_complete_greenp = (requestId) => {
  if (typeof window.grpCpaComp === 'function') {
    window.grpCpaComp({ uniq: requestId, price: 0 })
  }
}

export { landing_greenp, join_complete_greenp }
